// extracted by mini-css-extract-plugin
export default {"wrapper":"_3NgHGuSYkEkvr5LvHS74J3","title":"_2yFHE35GhCcD_-v_JDGxh-","desc":"_3pXch7VlE_YFoEN1IHXlL6","btn":"LCJ11Uzw13YtQX6f4ReR-"};